<div class="relative flex flex-col h-full min-h-0 bg-white overflow-y-auto md:overflow-hidden" [@rise]>

  <div class="relative flex-1 min-h-0 w-full h-full" [@stageSwitch]="stage()">
    @switch (stage()) {

      @case ('choose_billing_state') {
        @if (choosePackage(); as choosePackage) {
          <app-purchase-flow-stage-choose-billing
            [choosePackage]="choosePackage"
            (continueToInvoice)="onContinueToInvoice($event)">
          </app-purchase-flow-stage-choose-billing>
        }
      }

      @case ('support_error_state') {
        <div class="flex flex-col items-center justify-center gap-3 text-center h-full min-h-[320px] px-6 py-10 text-[#022d35]">
          <p class="text-[20px] font-bold leading-[1.3]">{{ 'plan_invoice_error.title' | translate }}</p>
          <p class="text-[14px] leading-[1.5] max-w-[420px]">{{ 'plan_invoice_error.text' | translate }}</p>
          @if (supportUrl(); as url) {
            <a [href]="url" target="_blank" rel="noopener noreferrer"
               class="text-[14px] font-bold underline hover:opacity-80">
              {{ 'plan_invoice_error.link' | translate }}
            </a>
          }
          <button type="button" (click)="close()"
                  class="mt-2 text-[13px] font-semibold text-[#6b7d82] hover:text-[#022d35]">
            {{ 'plan_invoice_error.close' | translate }}
          </button>
        </div>
      }

      @case ('invoice_state') {
        @if (invoiceUuid(); as invoiceUuid) {
          <app-invoice-plan-upgrade class="h-full flex flex-col min-h-0" (outputInvoiceStatus)="invoiceStatus.set($event)" [invoiceUuid]="invoiceUuid"></app-invoice-plan-upgrade>
        }
      }
    }

  </div>
</div>
